import { render } from "./WorskpaceFederationDatasetDialog.vue?vue&type=template&id=de047c02&scoped=true&ts=true"
import script from "./WorskpaceFederationDatasetDialog.vue?vue&type=script&lang=ts"
export * from "./WorskpaceFederationDatasetDialog.vue?vue&type=script&lang=ts"

import "./WorskpaceFederationDatasetDialog.vue?vue&type=style&index=0&id=de047c02&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de047c02"]])

export default __exports__